// extracted by mini-css-extract-plugin
export default {"primary":"donate-us_primary__4T7y-","error":"donate-us_error__9VWjD"};